import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "./Header";
import Footer from "./Footer";

function Reset() {
  const navigate = useNavigate();

  // Basic reset fields
  const [username, setUsername] = useState("");
  const [primaryContactEmail, setPrimaryContactEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleReset = (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    // First, check if the username exists
    axios.post("/check-username", { username: username.trim() })
      .then((res) => {
        if (res.data.exists) {
          // Now, check if the email exists in Contacts
          axios.post("/check-email", { email: primaryContactEmail.trim() })
            .then((emailRes) => {
              if (emailRes.data.exists) {
                // If both exist, send verification code
                const codeData = {
                  email: primaryContactEmail,
                  username,
                };
                axios.post("/code", codeData)
                  .then((res) => {
                    if (res.data.success) {
                      navigate("/verification-code", {
                        state: {
                          email: primaryContactEmail,
                          username,
                        }
                      });
                    } else {
                      console.error("Verification code error response:", res.data);
                      setErrorMessage(res.data.message || "Error sending verification code.");
                    }
                  })
                  .catch((err) => {
                    console.error("Code send error", err);
                    setErrorMessage("Error while sending verification code.");
                  });
              } else {
                // If email doesn't exist, show a popup
                alert("Email doesn't exist");
              }
            })
            .catch((err) => {
              console.error("Email check error", err);
              setErrorMessage("Error checking email.");
            });
        } else {
          // If username does not exist, show a popup alert
          alert("Username doesn't exist");
        }
      })
      .catch((err) => {
        console.error("Username check error", err);
        setErrorMessage("Error checking username.");
      });
  };

  return (
    <div className="Homepage flex flex-col justify-center h-full">
      <div className="login-container">
        <div className="Homepage-page flex flex-col w-full max-w-4xl py-4 mx-auto my-auto">
          {/* BOX 1: Title */}
          <div className="bg-white rounded-2xl shadow p-6 text-black mb-4">
            <h2 className="text-3xl font-arial normal-case no-underline">
              Reset Password:
            </h2>
          </div>

          {/* BOX 2: Form Fields */}
          <div className="bg-white rounded-2xl shadow p-6 text-black mb-4">
            {errorMessage && (
              <div className="bg-red-100 text-red-700 px-4 py-2 rounded mb-4">
                {errorMessage}
              </div>
            )}
            {successMessage && (
              <div className="bg-green-100 text-green-700 px-4 py-2 rounded mb-4">
                {successMessage}
              </div>
            )}
            <form id="resetForm" onSubmit={handleReset}>
              <div className="flex flex-wrap -mx-2">
                {/* Username */}
                <div className="w-full md:w-1/2 px-2 mb-4">
                  <label className="block font-semibold mb-1">Username</label>
                  <input
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Enter username here"
                    className="border rounded w-full p-2"
                    required
                  />
                </div>
                {/* Primary Contact Email */}
                <div className="w-full md:w-1/2 px-2 mb-4">
                  <label className="block font-semibold mb-1">Primary Contact Email</label>
                  <input
                    type="email"
                    value={primaryContactEmail}
                    onChange={(e) => setPrimaryContactEmail(e.target.value)}
                    placeholder="Enter your email here"
                    className="border rounded w-full p-2"
                    required
                  />
                </div>
              </div>
            </form>
          </div>

          {/* Action Buttons outside both boxes */}
          <div className="flex flex-wrap justify-center mt-6">
            <button
              type="submit"
              form="resetForm"
              className="bg-gray-300 text-black rounded px-4 py-2 mx-2 w-full sm:w-auto"
            >
              Send Verification Code
            </button>
            <button
              type="button"
              onClick={() => navigate("/")}
              className="bg-gray-300 text-black rounded px-4 py-2 mx-2 w-full sm:w-auto"
            >
              Return to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reset;
